import { render, staticRenderFns } from "./SettingsMachine.vue?vue&type=template&id=60fd5a5e&"
import script from "@/scripts/modal/rentalService/settingsMachine.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/rentalService/settingsMachine.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports